// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------------------------------------
# Search Box Container Section
--------------------------------------------------------------*/
.zYMuAvJCx6dZVDnYrJrV {
  padding: 0px !important;
}
.zYMuAvJCx6dZVDnYrJrV .XgvnxcRlCq7rYOLCm1GY {
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  color: var(--default-color);
}
.zYMuAvJCx6dZVDnYrJrV .XgvnxcRlCq7rYOLCm1GY .YqS2VBMpGAsrk1dQIHy0 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--accent-color);
}
.zYMuAvJCx6dZVDnYrJrV .XgvnxcRlCq7rYOLCm1GY .wHHA2E9aKwdsk3ZFo8we {
  font-weight: 400;
  color: #687E97;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .form-control {
  height: 48px;
  color: #0C3058;
  background-color: #ffffff;
  border: 1px solid #707070;
  border-radius: 30px !important;
  padding-right: 40px;
  box-shadow: 0px 1.55px 4.07px 0px rgba(0, 0, 0, 0.0236), 0px 7.32px 15.93px 0px rgba(0, 0, 0, 0.0364), 0px 19px 50px 0px rgba(0, 0, 0, 0.06);
  font-family: Rubik;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  padding-left: 110px;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .form-control::placeholder {
  color: #687E97;
  font-size: 16px;
  font-weight: 400;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .form-control:focus {
  border-color: #0068F5;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .form-control:focus::placeholder {
  color: transparent;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn, .zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-primary {
  height: 32px;
  width: 32px;
  position: absolute;
  left: 8px;
  top: 8px;
  border-radius: 100% !important;
  transition: all 0.3s;
  background-color: #0068F5 !important;
  color: #FFFFFF;
  z-index: 99;
  padding: 0;
  border: 0;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn:disabled, .zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-primary:disabled {
  opacity: 100%;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn:focus, .zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-primary:focus {
  outline: none;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn i, .zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-primary i {
  font-family: "bootstrap-icons";
  content: "\\f52a";
  font-size: 1.1rem;
}
html[dir=ltr] .zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn, html[dir=ltr] .zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-primary {
  left: auto;
  right: 8px;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-primary svg {
  bottom: 1px;
  position: relative;
  fill: #fff;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-clear {
  position: absolute;
  top: 8px;
  left: 98px;
  background: none !important;
  border: 1px solid #EBEEF2;
  border-radius: 8px !important;
  color: var(--default-color);
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-left: -2rem;
  cursor: pointer;
  transition: color 0.3s;
  z-index: 99;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-clear:hover {
  color: var(--accent-color) !important;
  background-color: transparent;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-clear:focus {
  box-shadow: none;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-clear svg {
  fill: #0C3058;
}
html[dir=ltr] .zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-clear {
  left: auto;
  right: 66px;
}
.zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-seperator {
  position: absolute;
  top: 8px;
  left: 52px;
  width: 1px;
  height: 32px;
  background-color: #D7DDE4;
  z-index: 98;
}
html[dir=ltr] .zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .btn-seperator {
  left: auto;
  right: 52px;
}
@media (max-width: 575.98px) {
  .zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy form {
    row-gap: 1rem;
  }
  .zYMuAvJCx6dZVDnYrJrV .kXiJ7pG2jfFIhJIChbOy .YtF1tZANnUrU1uTGD_YM {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 575.98px) {
  .zYMuAvJCx6dZVDnYrJrV {
    padding: 0 !important;
    width: 100%;
    margin: auto;
  }
  .zYMuAvJCx6dZVDnYrJrV .container {
    padding: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./GeneralComponents/SearchResults/searchBox/SearchBox.module.scss"],"names":[],"mappings":"AAAA;;+DAAA;AAGA;EACI,uBAAA;AACJ;AACI;EACI,iBAAA;EACA,qBAAA;EACA,2BAAA;AACR;AACQ;EACI,kBAAA;EACA,gBAAA;EACA,0BAAA;AACZ;AAEQ;EACI,gBAAA;EACA,cAAA;AAAZ;AAKQ;EACI,YAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4IAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAHZ;AAKQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AAHZ;AAMQ;EACI,qBAAA;AAJZ;AAMY;EACI,kBAAA;AAJhB;AASI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,8BAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AAPR;AASQ;EACI,aAAA;AAPZ;AAUQ;EACI,aAAA;AARZ;AAWQ;EACI,8BAAA;EACA,gBAAA;EACA,iBAAA;AATZ;AAYQ;EACI,UAAA;EACA,UAAA;AAVZ;AAgBQ;EACI,WAAA;EACA,kBAAA;EACA,UAAA;AAdZ;AAkBI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,2BAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;AAhBR;AAkBQ;EACI,qCAAA;EACA,6BAAA;AAhBZ;AAmBQ;EACI,gBAAA;AAjBZ;AAoBQ;EACI,aAAA;AAlBZ;AAqBQ;EACI,UAAA;EACA,WAAA;AAnBZ;AAuBI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;AArBR;AAuBQ;EACI,UAAA;EACA,WAAA;AArBZ;AA0BI;EAEQ;IACI,aAAA;EAzBd;EA4BU;IACI,WAAA;IACA,uBAAA;EA1Bd;AACF;;AA+BA;EACI;IACI,qBAAA;IACA,WAAA;IACA,YAAA;EA5BN;EA8BM;IACI,qBAAA;EA5BV;AACF","sourcesContent":["/*--------------------------------------------------------------\r\n# Search Box Container Section\r\n--------------------------------------------------------------*/\r\n.search-box-container {\r\n    padding: 0px !important;\r\n\r\n    .results-summary {\r\n        font-size: 1.1rem;\r\n        margin-bottom: 1.5rem;\r\n        color: var(--default-color);\r\n\r\n        .results-count {\r\n            font-size: 1.25rem;\r\n            font-weight: 600;\r\n            color: var(--accent-color);\r\n        }\r\n\r\n        .search-term {\r\n            font-weight: 400;\r\n            color: #687E97;\r\n        }\r\n    }\r\n\r\n    .search-form-wrapper {\r\n        :global(.form-control) {\r\n            height: 48px;\r\n            color: #0C3058;\r\n            background-color: #ffffff;\r\n            border: 1px solid #707070;\r\n            border-radius: 30px !important;\r\n            padding-right: 40px;\r\n            box-shadow: 0px 1.55px 4.07px 0px rgba(0, 0, 0, 0.0236), 0px 7.32px 15.93px 0px rgba(0, 0, 0, 0.0364), 0px 19px 50px 0px rgba(0, 0, 0, 0.06);\r\n            font-family: Rubik;\r\n            font-weight: 400;\r\n            font-style: Regular;\r\n            font-size: 16px;\r\n            line-height: 24px;\r\n            letter-spacing: 0%;\r\n            padding-left: 110px;\r\n\r\n        &::placeholder {\r\n            color: #687E97;\r\n            font-size: 16px;\r\n            font-weight: 400;\r\n        }\r\n\r\n        &:focus {\r\n            border-color: #0068F5;\r\n\r\n            &::placeholder {\r\n                color: transparent;\r\n            }\r\n        }\r\n    }\r\n\r\n    :global(.btn), :global(.btn-primary) {\r\n        height: 32px;\r\n        width: 32px;\r\n        position: absolute;\r\n        left: 8px;\r\n        top: 8px;\r\n        border-radius: 100% !important;\r\n        transition: all 0.3s;\r\n        background-color: #0068F5 !important;\r\n        color: #FFFFFF;\r\n        z-index: 99;\r\n        padding: 0;\r\n        border: 0;\r\n\r\n        &:disabled {\r\n            opacity: 100%;\r\n        }\r\n\r\n        &:focus {\r\n            outline: none;\r\n        }\r\n\r\n        i {\r\n            font-family: \"bootstrap-icons\";\r\n            content: \"\\F52A\";\r\n            font-size: 1.1rem;\r\n        }\r\n\r\n        :global(html[dir=ltr]) & {\r\n            left: auto;\r\n            right: 8px;\r\n        }\r\n    }\r\n\r\n    :global(.btn-primary) {\r\n\r\n        svg {\r\n            bottom: 1px;\r\n            position: relative;\r\n            fill: #fff;\r\n        }\r\n    }\r\n\r\n    :global(.btn-clear) {\r\n        position: absolute;\r\n        top: 8px;\r\n        left: 98px;\r\n        background: none !important;\r\n        border: 1px solid #EBEEF2;\r\n        border-radius: 8px !important;\r\n        color: var(--default-color);\r\n        font-size: 1.2rem;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        padding: 0;\r\n        margin-left: -2rem;\r\n        cursor: pointer;\r\n        transition: color 0.3s;\r\n        z-index: 99;\r\n\r\n        &:hover {\r\n            color: var(--accent-color) !important;\r\n            background-color: transparent;\r\n        }\r\n\r\n        &:focus {\r\n            box-shadow: none;\r\n        }\r\n\r\n        svg {\r\n            fill: #0C3058;\r\n        }\r\n\r\n        :global(html[dir=ltr]) & {\r\n            left: auto;\r\n            right: 66px;\r\n        }\r\n    }\r\n\r\n    :global(.btn-seperator) {\r\n        position: absolute;\r\n        top: 8px;\r\n        left: 52px;\r\n        width: 1px;\r\n        height: 32px;\r\n        background-color: #D7DDE4;\r\n        z-index: 98;\r\n\r\n        :global(html[dir=ltr]) & {\r\n            left: auto;\r\n            right: 52px;\r\n        }\r\n    }\r\n}\r\n\r\n    @media (max-width: 575.98px) {\r\n        .search-form-wrapper {\r\n            form {\r\n                row-gap: 1rem;\r\n            }\r\n\r\n            .btn {\r\n                width: 100%;\r\n                justify-content: center;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n    .search-box-container {\r\n        padding: 0 !important;\r\n        width: 100%;\r\n        margin: auto;\r\n\r\n        :global(.container) {\r\n            padding: 0 !important;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-box-container": `zYMuAvJCx6dZVDnYrJrV`,
	"results-summary": `XgvnxcRlCq7rYOLCm1GY`,
	"results-count": `YqS2VBMpGAsrk1dQIHy0`,
	"search-term": `wHHA2E9aKwdsk3ZFo8we`,
	"search-form-wrapper": `kXiJ7pG2jfFIhJIChbOy`,
	"btn": `YtF1tZANnUrU1uTGD_YM`
};
export default ___CSS_LOADER_EXPORT___;
